import _extends from 'babel-runtime/helpers/extends';

import { systemMessageListAPI, systemMessageReadAPI, systemMessageReadAllAPI, systemMessageClearAPI, systemMessageDeleteByIdAPI } from '@/api/common';
import { crmDownImportErrorAPI } from '@/api/crm/common';
import TodayListDetail from '@/views/calendar/components/TodayListDetail';
import SlideView from '@/components/SlideView';
import NewDialog from '@/views/oa/notice/NewDialog';
import MessageCell from './MessageCell';

import { getMaxIndex, downloadExcelWithResData } from '@/utils/index';
import { mapGetters } from 'vuex';

export default {
  // 导航头部系统消息
  name: 'SystemMessage',
  components: {
    SlideView: SlideView,
    NewDialog: NewDialog,
    MessageCell: MessageCell,
    TodayListDetail: TodayListDetail,
    CRMFullScreenDetail: function CRMFullScreenDetail() {
      return import('@/components/CRMFullScreenDetail');
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 仅公告
    onlyAnnouncement: {
      type: Boolean,
      default: false
    },
    unreadNums: Object
  },
  data: function data() {
    return {
      showTodayDetail: false,
      todayDetailData: {},
      showDetail: false,
      // 1 任务 2 日志 3 oa审批 4公告 5 日程 6 客户管理
      menuLabel: 'all',

      // 公告
      announcementAddShow: false,

      // 列表
      list: [],
      loading: false,
      noMore: false,
      scrollKey: Date.now(),
      page: 1,
      isUnRead: false, // 仅展示未读

      // CRM详情
      showFullDetail: false, // 查看相关客户管理详情
      relationID: '', // 相关ID参数
      relationCrmType: '' // 相关类型
    };
  },

  computed: _extends({}, mapGetters(['oa', 'crm', 'project']), {
    permissionSave: function permissionSave() {
      return this.oa && this.oa.announcement && this.oa.announcement.save;
    },
    title: function title() {
      if (this.onlyAnnouncement) {
        return this.unreadNums.announceCount && this.unreadNums.announceCount > 0 ? '\u516C\u544A\uFF08' + this.unreadNums.announceCount + '\uFF09' : '公告';
      }
      return this.unreadNums.allCunt > 0 ? '\u901A\u77E5\uFF08' + this.unreadNums.allCunt + '\uFF09' : '通知';
    },
    scrollDisabled: function scrollDisabled() {
      return this.loading || this.noMore;
    },
    labelValue: function labelValue() {
      if (this.onlyAnnouncement) {
        return 4;
      }
      return this.menuLabel == 'all' ? '' : this.menuLabel;
    },
    contentHeight: function contentHeight() {
      if (this.menuList.length > 7) {
        return 'calc(100% - 110px)';
      }
      return 'calc(100% - 155px)';
    },
    menuList: function menuList() {
      var menuList = [{
        name: '全部',
        label: 'all',
        countKey: 'allCount'
      }];

      if (this.oa) {
        // menuList.push({
        //   name: '公告',
        //   label: 4,
        //   countKey: 'announceCount'
        // })

        if (this.oa.taskExamine) {
          menuList.push({
            name: '办公审批',
            label: 3,
            countKey: 'examineCount'
          });
        }
      }

      if (this.oa && this.oa.taskExamine || this.project) {
        menuList.push({
          name: '任务',
          label: 1,
          countKey: 'taskCount'
        });
      }

      if (this.oa && this.oa.log) {
        menuList.push({
          name: '日志',
          label: 2,
          countKey: 'logCount'
        });
      }

      if (this.crm) {
        menuList.push({
          name: '客户管理',
          label: 6,
          countKey: 'crmCount'
        });
      }

      if (this.oa && this.oa.calendar) {
        menuList.push({
          name: '日程',
          label: 5,
          countKey: 'eventCount'
        });
      }

      return menuList;
    },
    currentMenu: function currentMenu() {
      var _this = this;

      return this.menuList.find(function (item) {
        return item.label === _this.menuLabel;
      });
    }
  }),
  watch: {
    visible: {
      handler: function handler(val) {
        this.showDetail = val;
        if (val) {
          this.$el.style.zIndex = getMaxIndex();
          this.refreshList();
        }
      },

      immediate: true
    },
    showDetail: function showDetail(val) {
      var _this2 = this;

      if (!val) {
        setTimeout(function () {
          _this2.$emit('update:visible', false);
        }, 350);
      }
    }
  },
  mounted: function mounted() {
    document.body.appendChild(this.$el);
    this.$el.addEventListener('click', this.handleDocumentClick, false);
  },
  beforeDestroy: function beforeDestroy() {
    // remove DOM node after destroy
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
      this.$el.removeEventListener('click', this.handleDocumentClick, false);
    }
  },

  methods: {
    /**
     * 日程事件
     */
    todayHandle: function todayHandle() {
      this.$bus.emit('handleSuccess');
      this.showTodayDetail = false;
    },


    /**
     * 新建公告
     */
    createNotice: function createNotice() {
      this.announcementAddShow = true;
    },
    announcementSubmiteSuccess: function announcementSubmiteSuccess() {
      var _this3 = this;

      setTimeout(function () {
        _this3.refreshList();
        _this3.$emit('update-count');
      }, 1000);
    },


    /**
     * 身体
     */

    /**
     * 菜单点击
     */
    menuClick: function menuClick(label) {
      this.menuLabel = label;
      this.refreshList();
    },


    /**
     * 刷新列表
     */
    refreshList: function refreshList() {
      this.page = 1;
      this.list = [];
      this.noMore = false;
      this.scrollKey = Date.now();
    },


    /**
     * 获取列表
     */
    getList: function getList() {
      var _this4 = this;

      this.loading = true;
      var params = {
        page: this.page,
        limit: 15,
        label: this.labelValue
      };
      if (this.isUnRead) {
        params.is_read = 0;
      }
      systemMessageListAPI(params).then(function (res) {
        _this4.loading = false;
        if (_this4.labelValue == params.label) {
          if (!_this4.noMore) {
            if (_this4.page == 1) {
              _this4.list = res.data.page.list;
            } else {
              _this4.list = _this4.list.concat(res.data.page.list);
            }
            _this4.page++;
          }
          _this4.noMore = res.data.page.lastPage;
        } else {
          _this4.refreshList();
        }
      }).catch(function () {
        _this4.noMore = true;
        _this4.loading = false;
      });
    },


    /**
     * 查看详情
     */
    checkCRMDetail: function checkCRMDetail(type, id, dataIndex, data) {
      if (type === 'schedule') {
        this.relationID = id;
        if (data.content) {
          this.todayDetailData = data.content;
        }
        this.showTodayDetail = true;
      } else {
        this.relationID = id;
        this.relationCrmType = type;
        this.showFullDetail = true;
      }
    },


    /**
     * 下载错误数据
     */
    downloadError: function downloadError(data) {
      crmDownImportErrorAPI({ name: '导入错误数据', path: data.error_file_path }).then(function (res) {
        downloadExcelWithResData(res);
      }).catch(function () {});
    },


    /**
     * 读取消息
     */
    readMessageClick: function readMessageClick(messageId, index) {
      var _this5 = this;

      systemMessageReadAPI({ message_id: messageId }).then(function (res) {
        _this5.list[index].is_read = 1;
        _this5.$emit('update-count');
      }).catch(function () {});
    },
    deleteMessageClick: function deleteMessageClick(messageId, index) {
      var _this6 = this;

      this.$confirm('确定删除这条消息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        systemMessageDeleteByIdAPI({ message_id: messageId }).then(function (res) {
          _this6.list.splice(index, 1);
          _this6.$emit('update-count');
          _this6.$message.success('操作成功');
        }).catch(function () {});
      }).catch(function () {
        _this6.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    handleCommand: function handleCommand(action) {
      if (action === 'delete') {
        this.allDeleteClick();
      } else {
        this.allMarkDoneClick();
      }
    },


    /**
     * 全部标记完成
     */
    allMarkDoneClick: function allMarkDoneClick() {
      var _this7 = this;

      systemMessageReadAllAPI({
        label: this.labelValue
      }).then(function (res) {
        _this7.list.forEach(function (item) {
          item.is_read = 1;
        });
        _this7.$emit('update-count');
      }).catch(function () {});
    },


    /**
     * 全部删除
     */
    allDeleteClick: function allDeleteClick() {
      var _this8 = this;

      if (this.currentMenu) {
        var name = this.currentMenu.label == 'all' ? '' : this.currentMenu.name;
        this.$confirm('\u786E\u5B9A\u5220\u9664\u5168\u90E8' + name + '\u5DF2\u8BFB\u6D88\u606F?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          systemMessageClearAPI({
            label: _this8.labelValue
          }).then(function (res) {
            _this8.refreshList();
            _this8.$emit('update-count');
            _this8.$message.success('操作成功');
          }).catch(function () {});
        }).catch(function () {
          _this8.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      }
    },
    hiddenView: function hiddenView() {
      this.showDetail = false;
    },
    handleDocumentClick: function handleDocumentClick(e) {
      e.stopPropagation();
      if (this.$el == e.target) {
        this.showDetail = false;
      }
    }
  }
};